import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'tog-file-upload',
  templateUrl: 'file-upload.component.html',
  styleUrls: ['file-upload.component.scss']
})
export class FileUploadComponent implements OnInit, OnDestroy {
  @Input() placeholderFileName: string = '';
  @Input() title: string = '';
  // @Input() reset: EventEmitter<any>;
  @Input() fileTypes: string[]; // should not include the dot
  @Input() extensions: string[]; // will need to provide your own validators so the uploader can check that the right thing was passed

  @Input() set reset(typeToReset: string) {
    if (this.title === typeToReset) this.resetForm();
  }
  @Output('file-change') fileChange = new EventEmitter();
  @Output('wrong-file') wrongFile = new EventEmitter();

  isHoveringFile: boolean = false;
  file: any;
  fileSrc: string;
  fileName: string = '';
  validFile: boolean = true;
  fileReader: FileReader = new FileReader();
  subscriptions: any[] = [];

  constructor() {
    let self = this;
    this.fileReader.onloadend = function (e) {
      self.fileSrc = 'url(' + self.fileReader.result + ')';
      let dataType = self.fileReader.result.split(';')[0];
        if (!self.checkType(dataType, 'data:')) {
          self.wrongFile.emit();
          self.fileSrc = '';
          self.fileName = '';
          self.validFile = false;
        }
        else {
          self.validFile = true;
        }
    };
  }

  ngOnInit() {
    // if (this.reset) {
    //   this.reset.subscribe((e) => {
        // if (this.title === e) {
        //   this.fileSrc = null;
        //   this.fileName = '';
        //   this.file = null;
        // }
    //   });
    // }
  }

  resetForm() {
    this.fileSrc = null;
    this.fileName = '';
    this.file = null;
  }

  checkType(dataType: any, header?: string): boolean {
    if (!header) header = '';
    let validTypes = this.fileTypes.filter((fileType) => {
      let dataCheck = header + fileType;
      return dataType == dataCheck;
    });
    return validTypes.length > 0;
  }

  eventFileReader(file) {
    if (!this.checkType(file.type)) {
      this.wrongFile.emit();
      this.validFile = false;
      this.fileName = '';
    }
    else { this.validFile = true; }
    if (this.fileChange) {
      this.fileChange.emit({ file: file || null });
    }
    if (file && this.validFile) {
      this.fileName = file.name;
      this.fileReader.readAsDataURL(file);
    }
  }

  fileDidChange(event) {
    if (event.target && event.target.files) {
      let file = event.target.files[0];
      this.eventFileReader(file);
    } else if (event.srcElement && event.srcElement.files) {
      let file = event.srcElement.files[0];
      this.eventFileReader(file);
    }
    else {
      if (this.fileChange) this.fileChange.emit({ file: null });
    }
  }


  getAcceptedExtensionsString() {
    let newString = '';
    this.extensions.forEach((extension) => {
      newString += '.' + extension + ',';
    });
    newString = newString.slice(0,(newString.length - 1)); // removes last comma
    return newString;
  }

  // Handlers for file drag and drop
  @HostListener('dragover', ['$event'])
  public onDragOver(e: any): void {
    let files = e.target.files || e.dataTransfer.files;
    this.isHoveringFile = true;
    this.preventAndStopEventPropagation(e);
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(e: Event): void {
    this.isHoveringFile = false;
    this.preventAndStopEventPropagation(e);
  }

  @HostListener('drop', ['$event'])
  public onDrop(e: any) {
    this.isHoveringFile = false;
    let files = e.target.files || e.dataTransfer.files;
    if (files.length) this.eventFileReader(files[0]);
    this.preventAndStopEventPropagation(e);
  }

  preventAndStopEventPropagation(e: any) {
    e.preventDefault();
    e.stopPropagation();
  }

  ngOnDestroy() {
    // if (this.reset) {
    //   this.reset.unsubscribe();
    // }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/file-upload/file-upload.component.ts